<span [matTooltip]="tooltip" matTooltipClass="disclosure-tooltip">{{text}}</span>